import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPersonOutline = function SvgPersonOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0009 3.5C10.344 3.5 9.0009 4.84314 9.0009 6.5 9.0009 8.15686 10.344 9.5 12.0009 9.5 13.6578 9.5 15.0009 8.15686 15.0009 6.5 15.0009 4.84314 13.6578 3.5 12.0009 3.5ZM7.5009 6.5C7.5009 4.01472 9.51562 2 12.0009 2 14.4862 2 16.5009 4.01472 16.5009 6.5 16.5009 8.98528 14.4862 11 12.0009 11 9.51562 11 7.5009 8.98528 7.5009 6.5ZM4.27995 17.8527C5.43643 14.7257 8.27919 12.5 12.0009 12.5 15.7226 12.5 18.5653 14.7257 19.7218 17.8527 20.0282 18.6812 19.82 19.4953 19.331 20.078 18.8524 20.6484 18.1091 21 17.3041 21H6.69774C5.89267 21 5.1494 20.6484 4.67078 20.078 4.18183 19.4953 3.97352 18.6813 4.27995 17.8527ZM12.0009 14C8.94031 14 6.63735 15.8029 5.68682 18.3731 5.58445 18.6498 5.64406 18.9043 5.81985 19.1138 6.00598 19.3357 6.32429 19.5 6.69774 19.5H17.3041C17.6775 19.5 17.9958 19.3357 18.1819 19.1139 18.3577 18.9044 18.4173 18.6499 18.315 18.3731 17.3644 15.8029 15.0615 14 12.0009 14Z"
  })));
};

export { SvgPersonOutline as ReactComponent };
//# sourceMappingURL=person-outline.svg.js.map
